import { MIN_SOFTWARE_FOR_DEVICE_CONFIG } from "Constants";
import { HardwareModel } from "generated/graphql.schema";
import { compareVersion } from "./stringUtils";

export const isPolyOS = (model: string) => {
  const m = model.toLowerCase();
  return (
    m.includes("x30") ||
    m.includes("x50") ||
    m.includes("x70") ||
    m.includes("7500")
  );
};
export const isDefaultProvisionedDevice = (model: string) => {
  return isUsbDevice(model);
};
export const isVVX = (model: string) => {
  return model.toLowerCase().includes("vvx");
};
export const isCCX = (model: string) => {
  return model.toLowerCase().includes("ccx");
};
export const isTrio = (model: string) => {
  return model.toLowerCase().includes("trio");
};
export const isUcsDevice = (model: string) => {
  return isVVX(model) || isCCX(model) || isTrio(model);
};
export const isUsbDevice = (model: string) => {
  const m = model.toLowerCase();
  return m.includes("studio usb") || m.includes("eagleeye cube");
};

export const isEagleEyeCube = (model: string) => {
  return model.toLowerCase().includes("eagleeye cube");
};

export const isStudioUSB = (model: string) => {
  return model.toLowerCase().includes("studio usb");
};

export const isLensRelay = (model: string) => {
  const m = model.toLowerCase();
  return m.includes("lens") && m.includes("relay");
};

export const isEdge = (model: string) => {
  return model.toLowerCase().includes("edge");
};

export const isEdgeE = (model: string) => {
  return model.toLowerCase().includes("edge e");
};

export const deviceHasExtraOptions = (
  supportsSettings: boolean | null | undefined,
  supportsSoftwareUpdate: boolean | null | undefined,
  provisioningEnabled: boolean | null | undefined
) => {
  return (
    supportsSettings || supportsSoftwareUpdate || provisioningEnabled || false
  );
};

export const deviceSupportsExportConfig = (
  deviceModel: string,
  softwareVersion?: string | null
) => {
  const isSupportedVersion =
    !!softwareVersion &&
    compareVersion(softwareVersion, MIN_SOFTWARE_FOR_DEVICE_CONFIG) >= 0;
  return isUcsDevice(deviceModel) && isSupportedVersion;
};

export function findCatalogModel(
  key: string | undefined,
  catalogModels: HardwareModel[]
): HardwareModel | undefined {
  return catalogModels?.find(catalogModel =>
    matchesCatalogModel(key, catalogModel)
  );
}

// search id, names and alias for the model
export function matchesCatalogModel(
  name: string | undefined,
  catalogModel: HardwareModel
): boolean {
  if (!name) {
    return false;
  }
  if (catalogModel.id === name) {
    return true;
  }
  const m = name.toUpperCase();
  return (
    catalogModel.name.toUpperCase() === m ||
    catalogModel.aliases?.map(alias => alias.toUpperCase()).includes(m) ||
    false
  );
}
